import React from 'react'
import { REMOVE_IMPLEMENTED_INTRO, REMOVE_IMPLEMENTED_NOTE, removeFromLayoutQuestion } from './layoutBuilderCopy'

// Body of the "remove from layout" confirmation: the question, then (when the item was implemented) the
// integrations it was implemented as and the note that removing it from the plan deletes none of them.
export default function RemoveFromLayoutMessage ({ name, implementedNames }) {
  return (
    <div>
      <p>{removeFromLayoutQuestion(name)}</p>
      {implementedNames.length > 0 && (
        <>
          <p>{REMOVE_IMPLEMENTED_INTRO}</p>
          <ul>
            {implementedNames.map((implementedName, index) => <li key={index}>{implementedName}</li>)}
          </ul>
          <p>{REMOVE_IMPLEMENTED_NOTE}</p>
        </>
      )}
    </div>
  )
}
